import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/tooltip/tooltip'

import { cn } from '@/lib/utils'

import { DocumentButton } from './document-button'
import { type DocumentData } from './types'

const TOOLTIP_CHAR_THRESHOLD = 20

export interface DocumentItemProps {
  item: DocumentData
  onClick: VoidFunction
}

export const DocumentItem = ({ item, onClick }: DocumentItemProps) => {
  const { name } = item

  return (
    <>
      {name.length < TOOLTIP_CHAR_THRESHOLD ? (
        <DocumentButton item={item} onClick={onClick} />
      ) : (
        <TooltipProvider delayDuration={250}>
          <Tooltip>
            <TooltipTrigger asChild>
              <DocumentButton item={item} onClick={onClick} />
            </TooltipTrigger>
            <TooltipContent side="right" align="center" className={cn('w-fit', 'px-2 py-1')}>
              <p className={cn('text-xs')}>{name}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
    </>
  )
}
